export const authPrefix = "/app";

//public
export const DEFAULT = "/";
export const LOGIN = "/login";
export const FORGOT_PASSWORD = "/forgot-password";
export const REGISTER = "/register";

//auth
export const DEFAULT_ADMIN = "/";
export const PROFILE = authPrefix + "/profile";
export const DASHBOARD = authPrefix + "/dashboard";
export const CHANGE_PASSWORD = authPrefix + "/change-password";

export const MODEM_SERVICE = authPrefix + "/modem-service";

//user: người dùng
export const USER_PAGE = authPrefix + "/users";
export const PERMISSION_PAGE = authPrefix + "/permissions";

//user: nhân viên
export const KEY_PAGE = authPrefix + "/keys";
export const KEY_DETAIL_PAGE = authPrefix + "/keys/:keyId";
//log: Log
export const HISTORY_PAGE = authPrefix + "/histories";

//danh mục quản lý
export const MEASUREMENT_UNIT_PAGE = authPrefix + "/measurement-units";
export const REGION_PAGE = authPrefix + "/regions";
export const WAREHOUSE_PAGE = authPrefix + "/warehouses";
export const PRODUCT_CATEGORY_PAGE = authPrefix + "/product-categories";
export const PRODUCT_PAGE = authPrefix + "/products";
export const INVENTORY_PAGE = authPrefix + "/inventories";
export const PARTNER_PAGE = authPrefix + "/partners";
export const BANK_ACCOUNT_PAGE = authPrefix + "/bank-account";

//đơn hàng
export const PURCHASE_ORDER_PAGE = authPrefix + "/purchase-orders";
export const PURCHASE_ORDER_CREATE_PAGE = PURCHASE_ORDER_PAGE + "/create";
export const PURCHASE_ORDER_DETAIL_PAGE = PURCHASE_ORDER_PAGE + "/detail/:id";
export const SALES_ORDER_PAGE = authPrefix + "/sales-orders";
export const SALES_ORDER_CREATE_PAGE = SALES_ORDER_PAGE + "/create";
export const SALES_ORDER_DETAIL_PAGE = SALES_ORDER_PAGE + "/detail/:id";

//công nợ
export const DEBT_RECEIPT_CREATE_PAGE = authPrefix + "/debt-receipt/create";
export const DEBT_RECEIPT_DETAIL_PAGE = authPrefix + "/debt-receipt/detail/:id";
export const DEBT_PAGE = authPrefix + "/debts";
export const DEBT_DETAIL_PAGE = DEBT_PAGE + "/detail/:id";

//báo cáo
export const REPORT_PAGE = authPrefix + "/reports";

//file export
export const EXPORT_JOBS_PAGE = authPrefix + "/export-jobs";
